import React,{useEffect} from 'react'

export default function Login() {
    useEffect(() => {
        localStorage.clear()
        window.location.href="/shop";
    },[])
    return(
    <div></div>
    )
}